import React, { FunctionComponent } from 'react';
import {
  Block,
  BlockProduct,
  BlockProductListSkeleton,
} from '@views/components/block/Block';

export const Placeholder: FunctionComponent<any> = () => (
  <Block>
    <Block.Header className="mb-3">
      <Block.Title>&nbsp;</Block.Title>
    </Block.Header>
    <BlockProduct>
      <BlockProduct.Body>
        <BlockProduct.List>
          <BlockProductListSkeleton />
        </BlockProduct.List>
      </BlockProduct.Body>
    </BlockProduct>
  </Block>
);

export default Placeholder;
